// ActionButtons.js
import { Button, Group } from "@mantine/core";
import React from "react";

const ActionButtons = ({
  onCancel,
  type,
  activeTab,
  onSave,
  loading,
  isFacility,
}) => {
  console.log("🚀 ~ ActionButtons ~ activeTab:", activeTab);
  return (
    <Group grow>
      <Button
        fullWidth
        color="gray"
        variant="light"
        c={"var(--app-text)"}
        onClick={onCancel}
        style={{ width: "50%" }}
      >
        Cancel
      </Button>
      <Button
        fullWidth
        c={"var(--app-on-primary)"}
        color="yellow"
        onClick={onSave}
        type={type}
        loading={loading}
        style={{ width: "50%" }}
      >
        {activeTab === "roles and permissions"
          ? "Save"
          : activeTab === "settings"
          ? "Save" : activeTab === 'details' ? "Save and Next" : isFacility ? "Save"
          : "Save and Next"}
      </Button>
    </Group>
  );
};

export default ActionButtons;
